import { COMPANY_APP_ORIGIN, ROUTES } from '../config/constants'

const trimTrailingSlash = (url: string) => url.replace(/\/$/, '')

export function resolveCompanyAppOrigin(): string {
  if (COMPANY_APP_ORIGIN) {
    return COMPANY_APP_ORIGIN
  }
  return window.location.origin
}

/** Путь в SPA frontend/company (basename /company). */
export function normalizeCompanyOrdersPath(pathname: string): string {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`
  if (path.startsWith(`/${ROUTES.COMPANY}/`)) {
    return path
  }
  if (path === `/${ROUTES.ORDERS}` || path.startsWith(`/${ROUTES.ORDERS}/`)) {
    return `/${ROUTES.COMPANY}${path}`
  }
  return path
}

export function buildCompanyAppUrl({ pathname, search = '', hash = '' }: ApplicationBuildCompanyAppUrlArgs): string {
  const path = `${normalizeCompanyOrdersPath(pathname)}${search}${hash}`
  const origin = trimTrailingSlash(resolveCompanyAppOrigin())
  return `${origin}${path}`
}

export const companyOrdersListPath = () =>
  `/${ROUTES.COMPANY}/${ROUTES.ORDERS}/${ROUTES.LIST}`

export const companyOrderDetailPath = (requestId: string) =>
  `/${ROUTES.COMPANY}/${ROUTES.ORDERS}/${requestId}`
